var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWhyInvestIcon1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20.955,
    height: 25.153,
    viewBox: "0 0 20.955 25.153",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "why-invest-icon-1",
    d: "M741.635,486.553l10.478,2.1a1.048,1.048,0,0,1,.842,1.027v18.853a1.048,1.048,0,0,1-.842,1.027l-10.478,2.1a1.048,1.048,0,0,1-1.253-1.027V487.58a1.2,1.2,0,0,1,.384-.81A.877.877,0,0,1,741.635,486.553Zm-3.349,2.075v20.949h-5.239a1.048,1.048,0,0,1-1.031-.859l-.017-.188V489.676a1.048,1.048,0,0,1,.859-1.031l.188-.017Zm7.334,9.427a1.048,1.048,0,1,0,1.048,1.048A1.048,1.048,0,0,0,745.621,498.054Z",
    transform: "translate(-732 -486.52)",
    fill: "#fff"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWhyInvestIcon1);
export default __webpack_public_path__ + "static/media/why-invest-icon-1.eead6debf2c7802ed6faba404c4b10b9.svg";
export { ForwardRef as ReactComponent };